<template>
  <div class="faults">
    <div class="filters">
      <Dropdown v-model="selectedStatus" :options="statusList" />
      <span class="p-input-icon-left">
        <i class="pi pi-filter" />
        <InputText type="text" v-model="filterText" placeholder="Filter" />
      </span>
    </div>
    <div class="fault_list">
      <div class="fault" v-for="f in filteredFaults" :key="f.id">
        <div class="p-d-flex p-jc-center">
          <div class="admin p-px-3">
            <h3 class="p-m-2">{{ f.admin }}</h3>
          </div>
        </div>

        <div class="desc">
          <h3 class="p-m-0">{{ f.desc }}</h3>
        </div>

        <div class="mechanic item">
          <div>Mechanic:</div>
          <b v-if="f.mechanic"
            >{{ f.mechanic.rank }} {{ f.mechanic.lastname }} || Pers.#
            {{ f.mechanic.persno }}
          </b>
          <b v-else class="assigned item">Not assigned</b>
        </div>


        <Button
          type="button"
          label="Mark As Complete!"
          icon="pi pi-check-circle"
          class="p-button-warning p-mb-3"
          @click="partOrdered()"
        />

      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fs } from "../firebase";
import { format } from "date-fns";
import Dropdown from "primevue/dropdown";

export default {
  name: "NewFaults",
  components: {
    // Dialog,
    Dropdown,
  },
  data() {
    return {
      faults: [],
      confirmRemoveDialog: false,
      filterText: "",
      selectedStatus: "Needs Entered in GCSS",
      statusList: ["Entered into GCSS", "Needs Entered in GCSS"],
    };
  },
  async mounted() {
    await this.getFaults();
  },
  methods: {
    async getFaults() {
      this.loading = true;
      await fb_db
        .collection("faults")
        .get()
        .then((docs) => {
          this.faults = [];
          docs.forEach(async (doc) => {
            let item = doc.data();
            item.id = doc.id;
            let user = await item.user.get();
            item.user = user.data();
            if (item.mechanic) {
              console.debug("loading mech");
              let mech = await item.mechanic.get();
              item.mechanic = mech.data();
            }
            this.faults.push(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },
    confirmRemove(faults) {
      console.log("confirm remove");
      this.confirmRemoveDialog = true;
      this.removethisfault = faults;
    },
    deleteFault() {
      console.log("Remove fault: ", this.removethisfault);
      fb_db
        .collection("faults")
        .doc(this.removethisfault.id)
        .delete()
        .then(() => {
          this.removethisfault = null;
          this.getFaults();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:mm MM/DD/YYYY");
    },
  },
  computed: {
    filteredFaults() {
      return this.faults.filter((f) => {
        if (this.selectedStatus == "Needs Entered in GCSS") {
          return (
            f.completed == true &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Entered in GCSS") {
          return (
            f.completed == false &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.faults {
  .fault_list {
    .fault {
      width: 300px;

      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }

      .edit {
        background: $accent;
        // color: $text;
        cursor: pointer;
      }

      .delete {
        background: $primary;
        // color: $white;
        cursor: pointer;
      }

      .item {
        padding: 5px;
        text-align: left;

        b {
          margin-left: 25px;
        }

        div {
          font-size: 14px;
        }
      }

      .admin {
        color: #FFCC5C;
      }

      .techstatus {
        color: red;
        font-size: 25px;
      }

      .desc {
        color: #000000;
      }

      .verify {
      }

      .repairstatus {
      }

      .created {
      }

      .mechanic {
      }

      .assigned {
        color: #FFCC5C;
      }
    }
  }
}
</style>